module.exports = __webpack_public_path__ + "img/bj.034317b6.png";